import styled from "styled-components";
import { Dispatch, SetStateAction } from "react";
import { LuSave } from "react-icons/lu";
import { DayWorkedRow } from "../../../types/common.types";
import removeTimezone from "../../../utils/removeTimezone";
import AdminService from "../../../services/admin.service";
import { useGlobal } from "../../../context/global";

// Mismo diseño que las comisiones (Sales.tsx): tarjeta con cabecera negra + mini tabla con el
// monto editable y el toggle de auth, botón de guardar arriba a la derecha.
function DayComponent({ day, sellerName, updateDay }: { day: DayWorkedRow, sellerName: string, updateDay: Function }) {
    const { setMessage, setIsLoading } = useGlobal()

    async function save() {
        setIsLoading(true)
        try {
            await AdminService.updateShiftDay(day.id, Number(day.amount), day.authorized)
            setMessage({ type: 'success', content: 'Día actualizado' })
            setTimeout(() => setMessage(undefined), 2500)
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="tour">
            <div className="header">
                <div className="name">
                    <span>{sellerName} — {removeTimezone(day.shift_date)} ({day.role === 'seller' ? 'Vendedor' : 'Admin'} {day.periods})</span>
                </div>
                <div className="actions">
                    <button className="save" onClick={save}><LuSave/></button>
                </div>
            </div>
            <TableWrapper>
                <Table>
                    <thead>
                        <tr>
                            <th>Monto</th>
                            <th style={{width: '40px'}}>auth</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <input value={day.amount} type="number" onChange={e => updateDay(day.id, 'amount', Number(e.target.value))} />
                            </td>
                            <td><button onClick={() => updateDay(day.id, 'authorized', !day.authorized)} className={day.authorized ? 'selected' : ''}></button></td>
                        </tr>
                    </tbody>
                </Table>
            </TableWrapper>
        </div>
    )
}

interface DaysWorkedProps {
    shifts: DayWorkedRow[]
    setShifts: Dispatch<SetStateAction<DayWorkedRow[]>>
    sellerName: string
}

export default function DaysWorked({ shifts, setShifts, sellerName }: DaysWorkedProps) {
    function updateDay(id: string, key: keyof DayWorkedRow, value: any) {
        setShifts(prev => prev.map(d => d.id === id ? { ...d, [key]: value } : d))
    }

    if (!shifts.length) return null

    return (
        <Main>
            {shifts.map(day => (
                <DayComponent key={day.id} day={day} sellerName={sellerName} updateDay={updateDay} />
            ))}
        </Main>
    )
}

const Main = styled.div`
display: flex;
flex-direction: column;
gap: 15px;
width: 90%;
margin: auto;
margin-bottom: 15px;
overflow: unset;
.tour {
    background-color: ${props => props.theme.whiteBackground};
    border-radius: 10px;
    box-shadow: 0 3px 5px ${props => props.theme.blackTransparent};
    .header {
        .name {
            flex: 1;
            text-align: center;
        }
        .actions {
            height: 100%;
            display: flex;
            gap: 5px;
            padding: 5px;
            button {
                height: 100%;
                width: 50px;
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: none;
                border-radius: 5px;
                cursor: pointer;
                color: ${props => props.theme.white};
            }
            button.save {
                background-color: ${props => props.theme.yellowDark};
            }
        }
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 10px 10px 0 0;
        position: relative;
        height: 40px;
        background-color: ${props => props.theme.black};
        color: ${props => props.theme.white};
    }
}
`

const TableWrapper = styled.div`
width: 100%;
height: 100%;
overflow: hidden;
overflow-x: unset;
`

const Table = styled.table`
border-collapse: collapse;
position: relative;
table-layout: fixed;
height: 100%;
width: 100%;
thead {
    width: 100%;
    background-color: #FFFFFF;
}
th {
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
}
td {
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    > button {
        width: 20px;
        height: 20px;
        color: #FFF;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        line-height: 40px;
        background-color: ${props => props.theme.white};
        border: 1px solid ${props => props.theme.black};
        border-radius: 5px;
        cursor: pointer;
        transition: transform .3s ease;
        &:active {
            transform: scale(0.8);
        }
    }
    > button.selected {
        background-color: ${props => props.theme.blueLight};
    }
    input {
        width: 100%;
        height: 100%;
        text-align: center;
        border: none;
        background-color: rgba(0,0,0,0);
    }
}
tr {
    height: 40px;
    width: 100%;
}
`
